<h3 class="mb-3">{{ payment.status | i18nSelect: paymentStatuses }}</h3>
<p *ngIf="payment.status == 'success'" i18n>Thank you for your order.</p>
<p *ngIf="payment.status == 'failed'" i18n>
  There was a problem with your payment. You can try again, use a different card or contact your bank to resolve the
  issue.
</p>
<form [formGroup]="retryForm">
  <p *ngIf="payment.status == 'failed'">

    <ng-container *ngIf="payment.shift_id">
      <select *ngIf="payment.shift_id" class="form-select" formControlName="card">
        <option [ngValue]="null" i18n>Select payment method</option>
        <ng-container *ngIf="!organization.disable_card_payments">
          <option ngValue="new_card" i18n>New payment card</option>
          <option *ngFor="let card of currentUser.cards" [ngValue]="card.id">{{ card.number }} <ng-container
              i18n>expires</ng-container> {{ card.expire_month | number: '2.0-0' }}/{{ card.expire_year }}</option>
        </ng-container>
      </select>
      <br>
      <button type="button" [disabled]="!retryForm.valid" class="btn btn-primary w-100" (click)="retry()" i18n>Try
        again</button>
    </ng-container>

    <a *ngIf="!payment.shift_id" class="btn btn-primary w-100" routerLink="/settings" i18n>Try again</a>
  </p>
</form>

<table class="table w-auto info">
  <tr>
    <th i18n>Payment status</th>
    <td>{{ payment.status | i18nSelect: paymentStatuses }}</td>
  </tr>
  <tr *ngIf="payment.status == 'failed'">
    <th i18n>Payment error message</th>
    <td>
      <ng-container *ngIf="payment.type == 'tbc'">
        {{ payment.result_code | i18nSelect: paymentResultCodesTbc }}
      </ng-container>
      {{ payment.error_message }}
    </td>
  </tr>
  <tr>
    <th i18n>Payment amount</th>
    <td>{{ payment.amount | number:'1.2-2' }} {{ payment.currency }}</td>
  </tr>
  <tr>
    <th i18n>Payment ID</th>
    <td>{{ payment.payment_id }}</td>
  </tr>

  <tr *ngIf="payment.shift_id">
    <th i18n>Order ID</th>
    <td>{{ payment.shift.id }}</td>
  </tr>

  <tr *ngIf="payment.receipt_number">
    <th i18n>Receipt number</th>
    <td>{{ payment.receipt_number }}</td>
  </tr>
</table>


<div *ngIf="payment.shift_id" class="card mb-3">
  <div class="card-header">
    {{ payment.shift.start | date: 'EE' }} {{ payment.shift.start | date: 'shortDate' }}
    {{ payment.shift.start | date: 'H:mm - ' }} {{ payment.shift.end | date: 'H:mm' }} ({{ payment.shift.duration
    }} <span i18n>h</span>)
    {{ payment.shift.assignment | translateField: 'name' }}
  </div>
  <div class="card-body">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label" i18n>Location</label><br>
        <span *ngIf="payment.shift.customer.type != 'individual'">{{ payment.shift.customer.name }}&nbsp;</span>{{
        payment.shift.customer.street_address }} {{ payment.shift.customer.city }}
      </div>
      <div class="col-12" *ngIf="payment.shift.employee_id">
        <label class="form-label" i18n>Employee</label><br>
        <img [src]="'/api/customer/employees/' + payment.shift.employee.id + '/picture' | authImg | async"
          style="border-radius: 50%; height: 3rem;" class="me-2">
        {{ payment.shift.employee.first_name }}
      </div>
      <div class="col-12">
        <label class="form-label" i18n>Products &amp; services</label>
        <table class="table table-dark">
          <thead>
            <tr>
              <th i18n>Title</th>
              <th class="text-end" i18n>Number</th>
              <th class="text-end" i18n>Price</th>
              <th class="text-end" i18n>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payment.items">
              <td>{{ item | translateField: 'title' }}</td>
              <td class="text-end">{{ item.number }}</td>
              <td class="text-end">{{ item.amount | currency: organization.currency }}</td>
              <td class="text-end">{{ item.total| currency: organization.currency }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="3" i18n>Total</th>
              <th class="text-end">{{ payment.amount | currency: organization.currency }}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary w-100 mb-3" (click)="router.navigate(['/'])" i18n>Back to main</button>